import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, switchMap, catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { HTSEntry, ImportStatisticsResponse } from '../../../../website/src/app/tariff-simulator/models/tariff.model';
import { ApiService as apiPortalService } from '../../../../portal/src/app/service/api.service';

export interface DrayageFare {
  baseFare: number;
  bufferRate: any;
  bufferRatePercent: any;
  miles: number;
  isPort: boolean;
  routes: any[];
  longestRoute: any;
}
@Injectable({
  providedIn: 'root'
})

export class  ApiService {
  baseUrl = environment.baseUrl;
  apiUrl = environment.tarrifURL;
  portalURL = environment.portalURL;
  airliftnet = environment.airliftnet
  // airliftnet = "http://localhost:8586/"
  scollValue: any = 0;
  private extractData(res: Response) {
    const body = res;
    return body || <any>{};
  }
  private routeSource = new BehaviorSubject<string | null>(null);
  currentRoute$ = this.routeSource.asObservable();
  constructor(private http: HttpClient, @Inject(PLATFORM_ID) private platformId: Object,private apiPortalService: apiPortalService,) { }

  private drayageCache = new Map<string, Observable<DrayageFare | null>>();

  clearDrayageCache(): void {
  this.drayageCache.clear();
}

  getRateSearch(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_search/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  signUp(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/signup/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getCommonOption(body): Observable<any> {
    const requestUrl = this.baseUrl + '/common_search/' + body.type;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getValues(body: any): Observable<any> {
    return this.apiPortalService.getValues(body);
  }

  searchZipcodes(q: string): Observable<any> {
    return this.http.post<any>(environment.airliftnet + 'tracking/customer_service/zipcode_search/', { q: q, limit: 20 });
  }

  getPortSearch(obj: { limit: string | number | boolean; q: string | number | boolean; }): Observable<any> {
    const params = new HttpParams()
      .set('limit', !!obj.limit ? obj.limit : 10)
      .set('q', !!obj.q ? obj.q : '')
    const requestUrl = this.baseUrl + '/port_search/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getOrganisation(): Observable<any> {
    const requestUrl = this.baseUrl + '/organisation/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  getTracking(obj?: any): Observable<any> {
    const params = new HttpParams()
      .set('q', !!obj.q ? obj.q : '')
    const requestUrl = this.baseUrl + '/tools/tracking/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getVesselSchedule(obj: any): Observable<any> {
    const params = new HttpParams()
      .set('origin', obj.origin)
      .set('destination', obj.destination)
      .set('from', obj.from)
      .set('to', obj.to)
      .set('filter_type', obj.filter_type)
    const requestUrl = this.baseUrl + '/tools/vessel_schedule/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  createEnquiryForm(body: any): Observable<any> {
    // const requestUrl = this.baseUrl + '/admin/contact_form/';
    const requestUrl = this.airliftnet + 'tracking/blogs/contact_form';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getCountryCode(): Observable<any> {
    const requestUrl = this.baseUrl + '/country/';
    return this.http.get<any>(requestUrl).pipe(map(this.extractData));
  }

  scrolltop(id: any) {
    if (isPlatformBrowser(this.platformId)) {
      var myDiv = document.getElementById(id);
      if (!!myDiv) {
        myDiv?.scrollIntoView();
      }
    }
  }

  scrolltop1(element: HTMLElement | string): void {
    if (isPlatformBrowser(this.platformId)) {
      if (typeof element === 'string') {
        const myDiv = document.getElementById(element);
        if (myDiv) {
          myDiv.scrollIntoView();
        }
      } else if (element instanceof HTMLElement) {
        element.scrollIntoView();
      }
    }
  }

  scrollToSection(sectionId: any): void {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView(sectionId);
      }
    }
  }

  storeBookingInfo(body: any): Observable<any> {
    const requestUrl = this.baseUrl + '/store_booking_info/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  // for composing the mail
  isMobile() {
    var userAgent = navigator.userAgent || navigator.vendor;
    return (/android|avantgo|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ipad|iphone|ipod|iris|kindle|maemo|midp|mmp|mobile|nokia|palm|phone|pie|plucker|pocket|psp|series60|silk|smartphone|symbian|treo|up\.browser|up\.link|webos|wos/i.test(userAgent));
  }

  composeEmail(body: any) {
    var email = body.email || '';
    var subject = body.subject || '';
    var body = body.body || '';

    if (this.isMobile()) {
      var mailto_link = 'mailto:' + email;
      window.open(mailto_link, '_blank');
      // window.location.href = mailto_link;
    } else {
      var gmail_link = 'https://mail.google.com/mail/?view=cm&fs=1&to=' + encodeURIComponent(email) + '&su=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      window.open(gmail_link, '_blank');
      // window.location.href = gmail_link;
    }
  }

  getRateSearchInit(): Observable<any> {
    const params = new HttpParams()
    const requestUrl = this.baseUrl + '/rate_search_init/';
    return this.http.get<any>(requestUrl, { params }).pipe(map(this.extractData));
  }

  getRateSearchRoute(body): Observable<any> {
    const requestUrl = this.baseUrl + '/rate_search_route/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  setRoute(route: string) {
    this.routeSource.next(route);
  }


  visitorInfo(body): Observable<any> {
    const requestUrl = this.baseUrl + '/visitor/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  trackEmailClick(body): Observable<any> {
    const requestUrl = this.baseUrl + '/track_email_click/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }


  // User event capture for before login or signup
  visitorEvents(body): Observable<any> {
    const requestUrl = this.baseUrl + '/visitor_events/';
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  searchHTS(query: string, limit: number = 50): Observable<HTSEntry[]> {
    const params = new HttpParams()
      .set('q', query)
      .set('limit', limit.toString());
    return this.http.get<HTSEntry[]>(`${this.apiUrl}/search`, { params });
  }

  getHTSDetails(htsCode: string): Observable<HTSEntry> {
    return this.http.get<HTSEntry>(`${this.apiUrl}/hts/${htsCode}`);
  }

  getImportStatistics(htsCode: string, year?: number): Observable<ImportStatisticsResponse> {
    let params = new HttpParams();
    if (year) {
      params = params.set('year', year.toString());
    }
    return this.http.get<ImportStatisticsResponse>(`${this.apiUrl}/import-statistics/${htsCode}`, { params });
  }

  calculateDuty(request: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}calculate`, request);
  }

  getLowestFreight(originId: any): Observable<any> {
    return this.http.post<any>(`${this.airliftnet}tracking/customer_service/api/freight?origin_id=${originId}`, {});
  }

  getBlogsCategoryCount(): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/get/count`;
    return this.http.get<any>(requestUrl, { transferCache: false }).pipe(map(this.extractData));
  }

    //Fetches a list of blogs from the backend API with optional pagination and sorting.
  getBlogs(requestObj): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/`;
    let httpParams = new HttpParams()
      .set('limit', requestObj.limit ? requestObj.limit : 5)
      .set('page', requestObj.page ? requestObj.page : 0)
      .set('sort', requestObj.sort ? requestObj.sort : 'latest')
      .set('filter', requestObj.filter ? requestObj.filter : '')
      .set('q', requestObj.q ? requestObj.q : '');
    if (requestObj.ids?.length) {
      httpParams = httpParams.set('ids', requestObj.ids.join(','));
    }
    return this.http.get<any>(requestUrl, { params: httpParams, transferCache: false }).pipe(map(this.extractData));
  }

   getBlogById(id: number): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/${id}`;
    return this.http.get<any>(requestUrl, { transferCache: false }).pipe(map(this.extractData));
  }

  subscribeToBlogUpdates(email: string): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/subscribe`;
    return this.http.post<any>(requestUrl, { email }).pipe(map(this.extractData));
  }

  unsubscribeFromBlogUpdates(email: string): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/unsubscribe`;
    return this.http.post<any>(requestUrl, { email }).pipe(map(this.extractData));
  }

  getBlogSubscriptionStatus(email: string): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/subscription_status`;
    return this.http.get<any>(requestUrl, { params: { email } }).pipe(map(this.extractData));
  }

  saveBlogForUser(email: string, blogId: number): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/save`;
    return this.http.post<any>(requestUrl, { email, blog_id: blogId }).pipe(map(this.extractData));
  }

  unsaveBlogForUser(email: string, blogId: number): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/unsave`;
    return this.http.post<any>(requestUrl, { email, blog_id: blogId }).pipe(map(this.extractData));
  }

  getSavedBlogIdsForUser(email: string): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/blogs/saved_ids`;
    return this.http.get<any>(requestUrl, { params: { email } }).pipe(map(this.extractData));
  }

  logEvent(body: any): Observable<any> {
    const requestUrl = `${this.airliftnet}tracking/general/event/`;
    return this.http.post<any>(requestUrl, body).pipe(map(this.extractData));
  }

  getDrayageFare(fdValue: string, unlocode: string, dest: any): Observable<DrayageFare | null> {
  if (!fdValue || !dest?.location_code) return of(null);

  const key = `${fdValue}|${unlocode}|${dest.location_code}`;

  if (!this.drayageCache.has(key)) {
    const obs = this.apiPortalService
      .getCommonOption({ q: fdValue, limit: '10', type: 'all_port' })
      .pipe(
        switchMap((res: any) => {
          if (res?.statusCode !== 200 || !res?.info?.length) return of(null);

          const port = res.info[0];
          const isRail =
            port.location_type.includes('Ramp') || port.location_type.includes('ICD');
          const portType = isRail ? 'Rail' : 'Port';

          const mileBody = {
            from: `${fdValue} ${unlocode} ${portType}`,
            to: dest.route_address || `${dest.location_name} ${dest.location_code}`
          };

          return this.apiPortalService.getMile(mileBody).pipe(
            switchMap((mileRes: any) => {
              if (mileRes?.statuscode !== 200 || !mileRes?.Info?.routes?.length) {
                return of(null);
              }

              const routes = mileRes.Info.routes.map((route: any) => {
                const distanceKm =
                  route.legs.reduce((t: number, leg: any) => t + leg.distance.value, 0) / 1000;
                return {
                  summary: route.summary,
                  distance: {
                    km: distanceKm,
                    miles: distanceKm * 0.621371,
                    text: `${distanceKm.toFixed(2)} km`
                  }
                };
              });

              const longestRoute = routes.reduce((prev: any, cur: any) =>
                prev.distance.miles > cur.distance.miles ? prev : cur
              );

              const miles = Math.round(Math.floor(longestRoute.distance.miles) * 2);

              const rateBody = {
                port_location: port.id.toString(),
                miles,
                zip_code: dest.location_code
              };

              return this.apiPortalService.getRate(rateBody).pipe(
                map((res1: any) => {
                  if (res1?.statuscode !== 200 || !res1?.Info?.length) return null;
                  return {
                    baseFare: res1.Info[0].fare,
                    bufferRate: res1.Info[0].buffer_rate,
                    bufferRatePercent: res1.Info[0].buffer_rate_percentage,
                    miles,
                    isPort: !isRail,
                    routes,
                    longestRoute
                  } as DrayageFare;
                })
              );
            })
          );
        }),
        catchError(() => of(null)),
        shareReplay({ bufferSize: 1, refCount: false })
      );

    this.drayageCache.set(key, obs);
  }

  return this.drayageCache.get(key)!;
}

}
